import { render, staticRenderFns } from "./showcase.vue?vue&type=template&id=967c51ce&scoped=true&"
import script from "./showcase.vue?vue&type=script&lang=ts&"
export * from "./showcase.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "967c51ce",
  null
  
)

export default component.exports